import { ChevronDown, ChevronUp } from "lucide-react-native";
import { FC, ReactNode, useState } from "react";

import { HStack, Pressable, Text, VStack } from "@/components/ui";
import { useLocalization } from "@/hooks";

interface AdvancedSettingsProps {
  children: ReactNode;
  /** Whether the accordion starts expanded. Defaults to false. */
  defaultExpanded?: boolean;
}

/**
 * Collapsible "Advanced settings" accordion. Hides secondary editor controls
 * (e.g. skip rules) behind a toggle to keep the editor focused on the primary
 * question authoring flow.
 */
const AdvancedSettings: FC<AdvancedSettingsProps> = ({
  children,
  defaultExpanded = false,
}) => {
  const { i18n } = useLocalization();
  const [expanded, setExpanded] = useState(defaultExpanded);
  const Chevron = expanded ? ChevronUp : ChevronDown;

  return (
    <VStack className="gap-3">
      <Pressable
        className="self-start"
        onPress={() => setExpanded((prev) => !prev)}
      >
        <HStack className="items-center gap-1">
          <Text className="text-sm font-medium text-typography-600">
            {i18n.t("questions.advancedSettings")}
          </Text>
          <Chevron color="rgb(var(--color-typography-600))" size={14} />
        </HStack>
      </Pressable>
      {expanded && children}
    </VStack>
  );
};

export default AdvancedSettings;
